<template>
  <span>
    <my-navbar></my-navbar>    
    <banner :nombreServicio="nombreServicio"></banner>
    <div class="container"> 
        <el-row :gutter="20" id="coaching">
            <el-col :xs="24" ><h1 style="font-size: 35px !important" class="chevere-title">Desarrollo De Aplicaciones</h1></el-col>
            <br>
            <el-col :xs="24" :md="12">
                <p class="chevere-text-j">Capacitados para brindarte soluciones que se ajusten a tus necesidades ya sea una aplicación móvil o de escritorio, o una API que simplifique el  consumo de información, siempre con nuestra ideología modular que va a permitir que esa solución pueda escalar, crecer y cambiar a la par con tu empresa y sus necesidades. </p>
            </el-col>
            <el-col class="hidden-md-and-up" :xs="24"><img class="isotipo" src="@/../public/assets/images/services/desarrollo.jpg" alt="Desarrollo de aplicaciones" title="Desarrollo de aplicaciones"></el-col>

            <el-col class="hidden-sm-and-down" :md="12"><img class="isotipo" src="@/../public/assets/images/services/desarrollo.jpg" alt="Desarrollo de aplicaciones" title="Desarrollo de aplicaciones"></el-col>
        </el-row>    
    <tecnologias></tecnologias> 
    <contacto></contacto>
    <whatsapp></whatsapp>

    </div>
    <my-footer></my-footer>
  </span>
</template>

<script>
import Whatsapp from '@/sections/Whatsapp.vue';

import Banner from '@/sections/Banner.vue';
import MyNavbar from '@/sections/Navbar.vue';
import MyFooter from '@/sections/Footer.vue';
import Contacto from '@/sections/Contactanos.vue';
import Tecnologias from '@/sections/Tecnologias.vue';
export default {
    name: "Desarrollo de aplicaciones a la medida",
  data () {
    return {
      nombreServicio:"Desarrollo de aplicaciones a la medida"
    }
  },
  components: {    
    Banner,
    Whatsapp,

    Contacto,
    Tecnologias,
    MyNavbar,
    MyFooter
  }
}
</script>

<style>
  .container{
    width: 90%;
    margin: auto;
  }
</style>


// WEBPACK FOOTER //
// src/pages/services/Desarrollos.vue